module.exports = __webpack_public_path__ + "img/close.2a9adad9.svg";